import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import R from 'ramda';

const getContentBoxAlignment = ({
  contentBoxAlignmentDefault,
  contentBoxAlignmentOverridesByIndex = [],
  index,
}) => (
  R.compose(
    R.defaultTo(contentBoxAlignmentDefault),
    R.prop('value'),
    R.find(contentBoxAlignmentOverride => R.prop('index', contentBoxAlignmentOverride) === index),
  )(contentBoxAlignmentOverridesByIndex)
);

const enhanceCardsData = ({
  cardsData,
  contentBoxAlignmentDefault,
  contentBoxAlignmentOverridesByIndex,
}) => (
  cardsData && cardsData.map((data, index) => ({
    ...data,
    contentBoxAlignment: getContentBoxAlignment({
      contentBoxAlignmentDefault,
      contentBoxAlignmentOverridesByIndex,
      index,
    }),
  }))
);

const CardsContainer = ({
  cards,
  cardsStoreDataKey,
  childComponent: ChildComponent,
  contentBoxAlignmentDefault,
  contentBoxAlignmentOverridesByIndex,
  ...props
}) => (
  <ChildComponent
    {...props}
    cardsData={enhanceCardsData({
      contentBoxAlignmentDefault,
      contentBoxAlignmentOverridesByIndex,
      cardsData: cards[`${cardsStoreDataKey}`],
    })}
  />
);

const mapStateToProps = ({ content }) => ({
  cards: R.prop('cards')(content),
});

CardsContainer.propTypes = {
  cards: PropTypes.objectOf(PropTypes.arrayOf(PropTypes.shape({
    title: PropTypes.string,
    description: PropTypes.string,
  }))).isRequired,
  cardsStoreDataKey: PropTypes.string.isRequired,
  childComponent: PropTypes.func.isRequired,
  contentBoxAlignmentDefault: PropTypes.oneOf(['bottom', 'top', 'left', 'right']),
  contentBoxAlignmentOverridesByIndex: PropTypes.arrayOf(PropTypes.shape({
    index: PropTypes.number.isRequired,
    value: PropTypes.oneOf(['bottom', 'top', 'left', 'right']).isRequired,
  })),
};

export default connect(mapStateToProps)(CardsContainer);
